var React = require('react');

function IconText (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.162 7.338V16H5.823V7.338H2.915V5.262h8.154v2.076H8.162ZM15.377 16c-.79 0-1.39-.2-1.8-.6-.4-.4-.6-.985-.6-1.754V9.692h-1.139V7.923h.57c.307 0 .517-.072.63-.215.113-.154.17-.37.17-.646V5.738h2.046v2.185h1.6v1.77h-1.6v4.538h1.476V16h-1.353Z","fill":"#4D4540"}));
}

IconText.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = IconText;

IconText.default = IconText;
